import { get } from "./utils";
import { GetAccountResponse } from "../models/statuspage/get-account-response";

export const getAccount = async () => await get<GetAccountResponse>("accounts/selected");
